export function isRequestIcon(uri?: string | null): boolean {
  return !!uri?.includes('/request-icon.svg');
}
